import { render, staticRenderFns } from "./LawFirm.vue?vue&type=template&id=0926362e"
import script from "./LawFirm.vue?vue&type=script&lang=js"
export * from "./LawFirm.vue?vue&type=script&lang=js"
import style0 from "./LawFirm.vue?vue&type=style&index=0&id=0926362e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports